import { render, staticRenderFns } from "./SingleWrongTopic.vue?vue&type=template&id=e70d0964&scoped=true"
import script from "./SingleWrongTopic.vue?vue&type=script&lang=js"
export * from "./SingleWrongTopic.vue?vue&type=script&lang=js"
import style0 from "./SingleWrongTopic.vue?vue&type=style&index=0&id=e70d0964&prod&scoped=true&lang=css"
import style1 from "./SingleWrongTopic.vue?vue&type=style&index=1&id=e70d0964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70d0964",
  null
  
)

export default component.exports